// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2iCGw","inputDescription":"styles_inputDescription__26OLy"};